<!--自行检票入场-->
<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>

    <div class="jjnnjnsert cen mt10 mb10">
      <span class="">当前入场区域：{{ groundName }}</span>
      <!-- <van-cell class="" title="当前入场区域：" :value="groundName||'请选择'" :value-class="groundId?'z3':''" is-link @click="showGrounds=true" /> -->
    </div>
    <no-data
      v-if="dataLoaded && orders.length === 0"
      :content-height="contentHeight"
    ></no-data>
    <div class="pd dataDiv pm15" v-else>
      <div
        class="pd ffdyyewr sdfsdtywer mt15 pm15 checkPad"
        v-for="(order, index) in orders"
        :key="index"
        :class="(order.hasCheckIn || parkCloseTime)?'checkInPad':''"
      >
        <div v-if="!order.hasCheckOut"> <!-- 已出场不显示 -->
          <div class="fz16 z3 row pt10">
            <div class="col">车牌号码：
            <span class="" v-if="order.plateNumbers && order.plateNumbers.length>0" >
                <span class="zts" v-for="(plateNumber, index) in order.plateNumbers" :key="index">{{ plateNumber.licensePlateNumber }} </span>
            </span>
            </div>
          </div>
          <div class="jjnmmnxer mt10 pt10">
            <div class="mt10">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">参观日期 </span>
              </span>
              <span class="ml10 fz14 z6">{{ order.travelDate }}</span>
            </div>
            <div class="mt10 row">
              <div class="col">
                <span class="pr f_b">
                  <i class="f_i binknxerrt"></i>
                  <span class="kkmnmxerert">订单编号 </span>
                </span>
                <span class="ml10 fz14 z6">{{ order.listNo }}</span>
              </div>
              <van-button               
                type="primary"
                class="fz12 checkInBtn"
                :class="(order.hasCheckIn || parkCloseTime)?'checkInDisabledBtn':''"
                :disabled="order.hasCheckIn || parkCloseTime"
                :loading="loading && currentIndex === index"
                @click="onClick(index)"
                >{{ parkCloseTime ? "已闭馆" : (order.hasCheckIn ? "已入场" : "入场") }}</van-button
              >
            </div>  
            <div v-if="order.ageRanges.length === 0" class="mt10">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">参观人数 </span>
              </span>
              <span class="ml10 fz14 z6">{{ order.totalNum }}人</span>
            </div>
            <div
              v-else
              v-for="(ageRange, index) in order.ageRanges"
              :key="index"
              class="mt10"
            >
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">{{ ageRange.ageRangeName }} </span>
              </span>
              <span class="ml10 fz14 z6">{{ ageRange.personNum }}人</span>
            </div> 
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet
      v-model="showGrounds"
      :actions="grounds"
      @select="onGroundSelecter"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapState,mapActions } from "vuex";
import NoData from "@/components/NoData.vue";
import orderService from "@/services/orderService.js";
import appConsts from "@/store/consts.js";
import signalRHelper from "@/utils/signalRHelper.js";
import scenicService from "./../services/scenicService.js";
const connection = signalRHelper.buildCheckerNotificationConnection();

const today = moment().format("YYYY-MM-DD");

export default {
  props: {
    propGroundId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      loading: false,
      dataLoaded: false,
      currentIndex: -1,
      queryText: "",
      orders: [],
      groundName: "",
      groundId: this.propGroundId,
      grounds: [],
      showGrounds: false,
    };
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 90;
    },
    ...mapState({
      options: (state) => state.orderModule.options
    }),
    parkCloseTime(){
      var ctime = moment().format("HH:mm");
      if(ctime>=this.options.parkCloseTime)
      {
          return true;
      }else{
        return false;
      }
    }
  },
  components: {
    NoData,
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
    async onGroundSelecter(item) {
      this.groundId = item.value;
      this.groundName = item.name;
      this.showGrounds = false;
      await this.loadOrdersAsync();
    },
    async getGrounds() {
      this.wxLastBookTime = "";
      const grounds = await scenicService.getGroundComboboxItemsAsync({
        travelDate: today,
      });
      this.grounds = grounds.map((g) => {
        return {
          value: g.value,
          name: g.displayText,
        };
      });
    },
    async onClick(index) {
      if (!this.groundId) {
        this.$toast("请选择检票区域");
        this.showGrounds = true;
        return;
      }
      this.currentIndex = index;
      let order = this.orders[index];
      try {
        this.loading = true;
        if (!order.hasCheckIn) {
          await this.$dialog.confirm({
            title: "确定入场？",
          });
          await orderService.consumeOrderFromMobileAsync({ListNo:order.listNo,GroundId:this.groundId});
        } else {
          await this.$dialog.confirm({
            title: "确定出场？",
          });
          await orderService.checkOutOrderFromMobileAsync({ListNo:order.listNo,GroundId:this.groundId});
        }
      } catch (err) {
        return;
      } finally {
        await this.loadOrdersAsync();
        this.loading = false;
      }
    },
    async loadOrdersAsync() {
      if (!this.groundId) {
        this.$toast("请选择检票区域");
        this.showGrounds = true;
        return;
      }
      let orders = await orderService.getGroupOrdersBySelfAsync({QueryText:this.queryText,GroundId:this.groundId});
      orders.forEach((order) => {
        if (order.checkInTime) {
          order.checkInTime = moment(order.checkInTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        }
        if (order.checkOutTime) {
          order.checkOutTime = moment(order.checkOutTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        }
      });
      this.orders = orders;
      this.dataLoaded = true;
    },
    layzeLoadOrder() {
      //alert("layzeLoadOrder");
      setTimeout(this.loadOrdersAsync, 300);
    },
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  },
  async created() {
    await this.getGrounds();
    var ground = this.grounds.find(o => {return o.value==this.groundId;});
    if(ground){
      this.groundName=ground.name;
    }
    await this.loadOrdersAsync();

    connection.on("CheckIn", this.layzeLoadOrder);
    connection.on("CheckOut", this.layzeLoadOrder);
    connection.start();
    this.orders.forEach(order => {
      if(!order.hasCheckIn && !this.parkCloseTime){
        orderService.consumeOrderFromMobileAsync({ListNo:order.listNo,GroundId:this.groundId});
      }      
    });
  },
  beforeDestroy() {
    connection.stop();
    connection.off("CheckIn");
    connection.off("CheckOut");
  },
  mounted() {},
};
</script>
<style scoped>
.dataDiv {
  overflow: auto;
  position: fixed;
  width: 100%;
  height: calc(100vh - 100px);
}
.checkInBtn {
    background: #6DA0A9;
    border-color: #6DA0A9;
    width: 60px;
    height: 60px;
    margin-top: -5px;
    position: absolute;
    right: 30px;
    margin-top: 5px;    
    padding: 0;
    font-size: 16px !important;
}
.checkInDisabledBtn{
   background: #575757 !important;
   border-color: #575757 !important;
}
.checkPad{
  background-color: #d5e7d5;
}
.checkInPad{
  background-color: #e6e6f9 !important;;
}
</style>
